import { render, staticRenderFns } from "./_DraftingChart.vue?vue&type=template&id=38a66365&scoped=true&"
import script from "./_DraftingChart.vue?vue&type=script&lang=js&"
export * from "./_DraftingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a66365",
  null
  
)

export default component.exports